/**
 * Create notification when a user is assigned to a task
 */

import { db } from './firebase';
import { collection, addDoc, Timestamp, doc, getDoc } from 'firebase/firestore';
import { shouldSkipEaProjectBell } from './eaProjectBellPolicy';

export interface CreateTaskAssignmentNotificationParams {
  assigneeUserId: string;
  taskId: string;
  taskTitle: string;
  projectId: string;
  projectName: string;
  assignedByName: string;
}

export async function createTaskAssignmentNotification(
  params: CreateTaskAssignmentNotificationParams
): Promise<void> {
  const {
    assigneeUserId,
    taskId,
    taskTitle,
    projectId,
    projectName,
    assignedByName,
  } = params;

  try {
    const assigneeSnap = await getDoc(doc(db, 'users', assigneeUserId));
    if (
      shouldSkipEaProjectBell({
        designations: assigneeSnap.data()?.designations,
        type: 'task_assigned',
        projectId,
      })
    ) {
      return;
    }
    await addDoc(collection(db, 'userNotifications'), {
      userId: assigneeUserId,
      type: 'task_assigned',
      title: 'Task assigned to you',
      message: `${assignedByName} assigned you to "${taskTitle}" in ${projectName}`,
      read: false,
      taskId,
      projectId,
      createdAt: Timestamp.now(),
    });
  } catch (error) {
    console.error('[createTaskAssignmentNotification] Error:', error);
  }
}
